import { useRuntimeConfig } from "#imports";
export const useBlock = () => {
  const blockClasses = (block) => {
    let classes = [];
    if (block.idx != null && block.idx != void 0) {
      classes.push(`fk-block-${block.idx}`);
    }
    if (block && block.__component) {
      let c = block.__component;
      c = c.replace("block.", "");
      c = c.replace("flyingkiwi.", "");
      c = c.replace("flying-kiwi.", "");
      classes.push(`fk-block-${c}`);
    }
    if (block && block.settings && block.settings) {
      if (block.settings.classes) {
        classes = classes.concat(block.settings.classes.split(" "));
      }
    }
    if (block && block.layout) {
      classes.push(`layout-${block.layout}`);
    }
    return classes;
  };
  const blockComponent = (strapiComponentName) => {
    if (!strapiComponentName) {
      return "div";
    }
    const runtimeConfig = useRuntimeConfig();
    const customBlock = runtimeConfig.public.flyingkiwi?.blocks?.find(
      (c) => c.name == strapiComponentName
    );
    if (!customBlock) {
      console.warn(`No block found for ${strapiComponentName}`);
      return false;
    }
    return customBlock.component;
  };
  return { blockClasses, blockComponent };
};
